import { CLIENT_URL } from '@shared/config/api/api';
import { SearchProductItem } from '@widgets/Header/model/types/searchResponse';

export const searchByProduct = async (value: string): Promise<SearchProductItem[]> => {
  const res = await fetch(`${CLIENT_URL}/products/search?q=${value}`);
  return res.json();
};
